import React from "react";
import { useQuery } from "@apollo/client";
import { GET_SKU_RELATED_PRODUCTS } from "../../../apollo/gql/query/products.query";
import { CLOUD_FRONT_URL } from "../../../aws.config";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { alankaramDataAtom } from "../../../state";


interface RelatedProductsProps {
  skuId: string;
}

const RelatedProducts: React.FC<RelatedProductsProps> = ({ skuId }) => {

  const alankaramData = useRecoilValue(alankaramDataAtom);
  const { data, loading, error } = useQuery(GET_SKU_RELATED_PRODUCTS, {
    variables: { skuId, companyId:alankaramData?.companyId },
    skip: !(skuId && alankaramData?.companyId),
    fetchPolicy: "cache-and-network",
  });

  const navigate = useNavigate()

  if (loading) return null;
  if (error) return <div>Error loading related products.</div>;
  if (!data?.getSKURelatedProducts?.length) return null;

  return (
    <div className="p-3">
      <div className="flex justify-center">
        <div className="related-products-list flex gap-4">
          {data?.getSKURelatedProducts?.map((product: any) => (
            <div
              key={product._id}
              onClick={() => navigate(`/products/product-detail/${product._id}`)}
              className="flex-shrink-0 w-56 border rounded-md cursor-pointer overflow-hidden flex flex-col justify-between"
            >
              <div className="flex-1 flex flex-col">
                <div className="aspect-w-16 aspect-h-9">
                  <img
                    className="w-full h-full object-cover max-h-full"
                    alt={product?.name}
                    src={`${CLOUD_FRONT_URL}${product?.thumb}`}
                  />
                </div>
              </div>
              <div className="flex justify-center pt-3 pb-2 px-2 text-center">{product?.sku || product?.uniqueCode} {product?.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RelatedProducts; 